import { useCallback, useRef } from 'react'

export function useDebounce(
  delay = 500
): [(listener: () => void) => void, () => void] {
  const ref = useRef({ timeoutRef: undefined })

  const debounce = useCallback(
    (listener: () => unknown) => {
      clearTimeout(ref.current.timeoutRef)
      ref.current.timeoutRef = setTimeout(listener, delay)
    },
    [delay]
  )

  const clearDebounce = useCallback(() => {
    clearTimeout(ref.current.timeoutRef)
  }, [])

  return [debounce, clearDebounce]
}
